/*  DUI Message
*   
*   DUImessage.show(
*       "Message text",    string []                - Message text
*       "Message-info"     string ['Message-info']  - (optional) 'Message-info', 'Message-error', 'Message-success'
*       0                  number ['Message-info']  - (optional) The time in milliseconds that a message will wait before being automaticaly removed
*   );
*
*   DUImessage.show("Your data has been successfully saved", "Message-success");
*   DUImessage.hide();
*/

window.DUImessage = (function() {
	"use strict";

	var messages = [],
		messageContainer = document.getElementById('DUIMessageWrapper') 
							|| createMessageContainer(); 
						   
	
	function createMessageContainer() {
		return $('<div/>', {
					'id': 'DUIMessageWrapper',
					'class': 'Message-fixed-wrapper'
				}).appendTo(document.body).get(0);
	}

	function createMessageElement(message, type) {
		return $('<p/>', {
					'class': 'Message ' + (type ? type : ' Message-info'),
					'html': message,
					'click': function() { removeMessageElement(this); }
				}).get(0);
	}

	function removeMessageElement(messageEl) {
		var index = messages.indexOf(messageEl);
		messages.splice(index, 1);
		$(messageEl).remove();
	}

    function position() {
        try {
            var dataModelUpdateMessage = $("div[id$='divDataModelUpdate'] .Message", top.document).outerHeight() ||
                $("div[id$='divInMemoryUpdate'] .Message", top.document).outerHeight();

            if (dataModelUpdateMessage)
                $(messageContainer).css('top', dataModelUpdateMessage);
        } catch (err) { /* empty */ }
    }

	function show(message, type, time) {
		var messageEl = createMessageElement(message, type);

		$('#DUIMessageWrapper').append(messageEl);
		messages.push(messageEl);
		position();

		if (typeof time === "number") {
			setTimeout(function() { removeMessageElement(messageEl); }, time);
		}

		return messageEl;
	}

	function hide(messageEl) {
		if (messageEl) {
			removeMessageElement(messageEl);
		} else {
			messages = [];
			$(messageContainer).empty();
		}
	}

	return {
		show: show,
		hide: hide,
		position: position
	};
})();